// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: none;
}
.modal-container.opened {
  display: flex;
}
.modal-container.closed {
  display: none;
}

.modal {
  width: 600px;
  max-width: calc(100% - 32px);
  max-height: 95vh;
  background: #fff;
  padding: 24px;
  margin: auto;
  box-sizing: border-box;
  border-radius: 10px;
  position: relative;
  overflow: auto;
  mask-image: radial-gradient(circle, white 100%, black 100%);
}
.modal__header {
  padding-bottom: 24px;
}
.modal__title {
  text-align: center;
  font-size: 32px;
}
.modal__close-button {
  position: absolute;
  right: 8px;
  top: 8px;
}
.modal__content {
  text-align: center;
}
.modal__content p {
  margin-bottom: 8px;
}
.modal__content strong {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;AACJ;AACI;EACE,aAAA;AACN;AACI;EACE,aAAA;AACN;;AAEE;EACE,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,2DAAA;AACJ;AAAI;EACE,oBAAA;AAEN;AAAI;EACE,kBAAA;EACA,eAAA;AAEN;AAAI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAEN;AAAI;EACE,kBAAA;AAEN;AAAM;EACE,kBAAA;AAER;AAAM;EACE,iBAAA;AAER","sourcesContent":[".modal-container {\n    position: fixed;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: none;\n  \n    &.opened {\n      display: flex;\n    }\n    &.closed {\n      display: none;\n    }\n  }\n  .modal {\n    width: 600px;\n    max-width: calc(100% - 32px);\n    max-height: 95vh;\n    background: #fff;\n    padding: 24px;\n    margin: auto;\n    box-sizing: border-box;\n    border-radius: 10px;\n    position: relative;\n    overflow: auto;\n    mask-image: radial-gradient(circle, white 100%, black 100%);\n    &__header {\n      padding-bottom: 24px;\n    }\n    &__title {\n      text-align: center;\n      font-size: 32px;\n    }\n    &__close-button {\n      position: absolute;\n      right: 8px;\n      top: 8px;\n    }\n    &__content {\n      text-align: center;\n    \n      p {\n        margin-bottom: 8px;\n      }\n      strong {\n        font-weight: bold;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
